import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SideModal from "../based/SideModal";
import CloseIcon from "./assets/CloseIcon.svg";
import FinanceServices from "../based/services/FinanceServices";
import { WalletStatusEnum } from "./BalanceWithdrawal";
import Common from "../based/Common";

function TransactionDetail({ show, onClose, id }) {
    const [detail, setDetail] = useState({});

    console.log("detail", detail);

    useEffect(() => {
        if (show && id > 0) getDetail(id);
    }, [id]);

    const getDetail = async (id) => {
        const [err, data] = await FinanceServices.GetWalletHistory(id);
        if (!err && data) {
            setDetail(data);
        } else {
            setDetail({});
        }
    };

    if (!detail)
        return (
            <div>
                <p>Loading...</p>
            </div>
        );
    return (
        <SideModal
            show={show}
            onClose={() => {
                onClose();
            }}
        >
            <Wrapper>
                <div class="transaction-detail">
                    <div class="transaction-detail__header">
                        <h2 class="transaction-detail__title">Chi tiết giao dịch</h2>
                        <button class="transaction-detail__close" aria-label="Đóng" onClick={onClose}>
                            <img src={CloseIcon} alt="Đóng" />
                        </button>
                    </div>
                    <div class="transaction-detail__section">
                        <div class="transaction-detail__type">
                            <span class="transaction-detail__type-icon">💸</span>
                            <span class="transaction-detail__type-label">{detail.walletTypeName}</span>
                        </div>
                        {detail.status === WalletStatusEnum.InProgress && (
                            <div class="transaction-detail__status transaction-detail__status--processing">
                                <span class="transaction-detail__status-icon">⚠️</span>
                                <div className="transaction-detail-right">
                                    <span class="transaction-detail__status-text">Giao dịch đang xử lý</span>
                                    <div class="transaction-detail__status-note">Thông tin sẽ được cập nhật sau khi hoàn thành.</div>
                                </div>
                            </div>
                        )}
                        {detail.status === WalletStatusEnum.Completed && (
                            <div class="transaction-detail__status transaction-detail__status--completed">
                                <div className="transaction-detail-right">
                                    <span class="transaction-detail__status-text">Giao dịch hoàn thành</span>
                                </div>
                            </div>
                        )}
                    </div>
                    <div class="transaction-detail__body">
                        <div class="transaction-detail__row">
                            <span class="transaction-detail__label">Số tiền</span>
                            <span class="transaction-detail__value transaction-detail__value--negative">{Common.formatCurrency(detail.amount)}</span>
                        </div>
                        <div class="transaction-detail__row">
                            <span class="transaction-detail__label">Thời gian</span>
                            <span class="transaction-detail__value">{Common.formatDate(new Date(detail.createdDate))}</span>
                        </div>

                        <div class="transaction-detail__row">
                            <span class="transaction-detail__label">Nội dung</span>
                            <span class="transaction-detail__value">{detail.description}</span>
                        </div>
                    </div>

                    {/* <div class="transaction-detail__footer">
                        <button class="transaction-detail__cancel-btn" type="button">
                            Hủy yêu cầu rút
                        </button>
                    </div> */}
                </div>
            </Wrapper>
        </SideModal>
    );
}

export default TransactionDetail;

const Wrapper = styled.div`
    .transaction-detail__status.transaction-detail__status--completed {
        border-radius: 8px;
        background: #d4f7e0;
        padding: 12px;
        margin: 12px 0;
    }

    .transaction-detail__status.transaction-detail__status--completed span {
        color: #28b259;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .transaction-detail__header {
        display: flex;
        align-items: center;
    }

    h2.transaction-detail__title {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    button.transaction-detail__close {
        margin-left: auto;
        border: none;
        background: none;
    }

    .transaction-detail__section {
    }

    .transaction-detail {
        padding: 0 12px;
    }

    span.transaction-detail__type-label {
        color: #303030;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: 12px;
    }

    .transaction-detail__status.transaction-detail__status--processing {
        border-radius: 8px;
        background: #fff1cb;
        padding: 12px;
        margin: 12px 0;
        display: flex;
        align-items: center;
    }

    .transaction-detail-right {
        margin-left: 12px;
    }

    span.transaction-detail__status-text {
        color: #ac6700;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .transaction-detail__status-note {
        color: #707070;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .transaction-detail__row {
        display: flex;
        align-items: center;
        margin: 12px 0;
    }

    span.transaction-detail__label {
        color: #707070;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 40%;
    }

    span.transaction-detail__value {
        flex: 1;
    }

    span.transaction-detail__value {
        flex: 1;
    }

    .transaction-detail__value--negative {
        color: #ff9027;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .transaction-detail__footer {
        display: flex;
        justify-content: center;
    }

    button.transaction-detail__cancel-btn {
        border-radius: 40px;
        border: 1px solid rgba(215, 0, 0, 0.2);
        background: #ffe4e4;
        color: #d70000;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        padding: 8px 20px;
    }
`;
